import {shallowEqual, useSelector} from "react-redux";
import {preprocessFile} from "../../LightboxContent/utils/preprocessFile";
import {getLightboxModalProps} from "../../LightboxContent/utils/getLightboxModalProps";

/**
 *
 * @param {LightboxType} lightboxType
 * @returns
 */
export const useCurrentLightboxAttributes = lightboxType => {
    const currentIndex = useSelector(state => state.Lightbox.currentIndex);
    const file = useSelector(state => state.Lightbox.files[currentIndex], shallowEqual);

    if (!file)
        return {};

    // console.log('aaa useCurrentLightboxAttributes', {file, currentIndex, lightboxType});
    const preprocessedFile = preprocessFile(file, undefined, lightboxType);
    const lightboxModalProps = getLightboxModalProps(preprocessedFile.lightboxProps);

    // const contentDOM = fileDOMS[currentIndex];
    // if (React.isValidElement(contentDOM)) {
    return {
        // file item props
        contentCaption: lightboxModalProps['content-caption'],
        contentFileName: lightboxModalProps['content-file-name'],
        contentSrc: lightboxModalProps['content-src'],
        contentMimeType: lightboxModalProps['content-lightbox-file-type'],
        contentLightboxType: lightboxModalProps['content-mime-type'],

        // modal props
        itemShowDownload: lightboxModalProps['item-show-download'],
    };
};
